import { Box, Button, Tooltip } from '@mui/material';
import { useState } from 'react';

export const CopyOnClickContainer = ({ copyContent, children }: { copyContent: string; children: React.ReactNode }) => {
  const [copyTooltip, setCopyTooltip] = useState('Copy to clipboard.');

  const handleCopy = () => {
    navigator.clipboard.writeText(copyContent);
    setCopyTooltip('Copied.');
    setTimeout(() => setCopyTooltip('Copy to clipboard.'), 2000);
  };

  return (
    <Tooltip title={copyTooltip} arrow placement="top">
      <Box component="span">
        <Button
          sx={{ mx: 1, minHeight: 0, minWidth: 0, p: 0 }}
          onClick={handleCopy}
          disabled={copyTooltip === 'Copied.'}
        >
          {children}
        </Button>
      </Box>
    </Tooltip>
  );
};
